import { render, staticRenderFns } from "./CreateDestinationModal.vue?vue&type=template&id=2b10110d"
import script from "./CreateDestinationModal.vue?vue&type=script&lang=ts"
export * from "./CreateDestinationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports